<template>
    <div>
        <el-row class="">
            <el-col>
                <div class="table-grd">
                    <div class="header">
                        <h1>{{ $t('Manage Cases') }}</h1>
                        <case-form :rowData="rowData" @popupupdate="updateRow" :dialogFormVisible="dialogFormVisible" @popupsave="getCases" @popup="value => { this.dialogFormVisible = value }" :fachstellenList="fachstellenList" :patenkinderList="patenkinderList" :organization_slug="filterData.organization_slug" :fachstellen_slug="fachstellen_slug" :fachstellenTypes="fachstellenTypes" :club_slug="club_slug" />
                        <ul class="icon-list">
                            <li v-if="$store.getters.getConfig('has_permissions').includes('patenkinders-cases-store')" class="case-create">
                                <a href="javascript:void(0);" @click="handleCreate()" :title="$t('Create')"><i class="icon-add"></i></a>
                            </li>
                            <li><a href="javascript:void(0)" @click="exportFile" :title="$t('Export')"><i class="icon-excel"></i></a></li>
                            <li><a href="javascript:void(0)" @click="listView = !listView" :title="(listView)?$t('Grid view'):$t('List view')"><i :class="(listView)?'icon-grid-view':'icon-list-view'"></i></a></li>
                            <li><a href="javascript:void(0)" :title="$t('Search')" v-collapse-toggle="'toggle_first'"><i class="icon-advance-search"></i></a></li>
                        </ul>
                    </div>
                    <v-collapse-group ref="group1">
                        <v-collapse-wrapper ref="toggle_second">
                            <div class="my-content table-desc">
                                <v-collapse-wrapper ref="toggle_first" class="search-data">
                                    <div class="my-content" v-collapse-content>
                                        <el-form :model="filterData" ref="filterData" :inline="true">
                                            <div class="bottom-dev">
                                                <el-col :xs="12" :sm="7" :md="7" :lg="6" :xl="4">
                                                    <el-form-item class="all-select">
                                                        <el-select v-model="selectedColumns" multiple placeholder="Columns" size="medium" collapse-tags>
                                                            <el-option v-for="(item) in column_name" :label="item.label" :value="item.value" :key="item.value"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="12" :sm="5" :md="4" :lg="3" :xl="3">
                                                    <el-form-item prop="case_title">
                                                        <el-input v-model="filterData.case_title" :placeholder="$t('Case')" size="medium" @keyup.enter.native="hadleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <span v-if="$store.state.config.user.fachstellen_slug || fachstellen_slug"></span>
                                                <el-col :xs="12" :sm="6" :md="5" :lg="3" :xl="3" v-else>
                                                    <el-form-item prop="fachstellen_slug">
                                                        <el-select v-model="filterData.fachstellen_slug" :placeholder="$t('Fachstellen')" size="medium" @change="getAllPatenkinder" filterable>
                                                            <el-option v-for="(item) in fachstellenList.data" :label="item.display_name" :key="item.slug" :value="item.slug"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3">
                                                    <el-form-item prop="patenkinder_slug">
                                                        <el-select v-model="filterData.patenkinder_slug" :placeholder="$t('Godchild')" size="medium" filterable>
                                                            <el-option v-for="(item) in patenkinderList.data" :label="item.display_name" :key="item.slug" :value="item.slug"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3">
                                                    <el-form-item prop="status">
                                                        <el-select v-model="filterData.status" :placeholder="$t('Status')" size="medium" filterable>
                                                            <el-option v-for="(item, key) in caseStages" :label="item" :key="key" :value="key"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="10" :md="8" :lg="6" :xl="4">
                                                    <div class="el-form-item">
                                                        <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange" size="small">{{
                                                            $t('Search') }}</el-button>
                                                        <el-button type="cancel" @click="resetForm('filterData')" size="small">{{
                                                            $t('Reset') }}</el-button>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-form>
                                    </div>
                                </v-collapse-wrapper>
                                <el-table class="cases-table" v-if="listView" :data="cases.data" @sort-change="handleSortChange" highlight-current-row key='aTable'>
                                    <el-table-column :label="$t('No.')" type="index" :index="indexMethod" width="100" fixed></el-table-column>
                                    <el-table-column :label="$t('Actions')" width="100" fixed v-if="($store.getters.getConfig('has_permissions').includes('patenkinders-cases-update') || $store.getters.getConfig('has_permissions').includes('patenkinders-cases-destroy'))">
                                        <template slot-scope="scope">
                                            <ul class="act-list" v-if="(scope.row.status_key == 'stage_1' || $store.state.config.user.role_slug==='main-admin')">
                                                <li v-if="($store.getters.getConfig('has_permissions').includes('patenkinders-cases-update') && ($store.state.config.user.role_slug==='fachstellen' || $store.state.config.user.role_slug==='fachstellen-user' || $store.state.config.user.role_slug==='organization-user' ||  $store.state.config.user.role_slug==='organization') || $store.state.config.user.role_slug==='main-admin')">
                                                    <a href="javascript:void(0);" @click="handleEdit(scope.row)"><i :class="(scope.row.status_key == 'stage_1') ? 'icon-edit' : 'el-icon-view'"></i></a>
                                                </li>
                                                <li v-if="$store.getters.getConfig('has_permissions').includes('patenkinders-cases-destroy')">
                                                    <a href="javascript:void(0);" @click="handleDelete(scope.$index, scope.row)"><i class=" icon-delete"></i></a>
                                                </li>
                                            </ul>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip :label="$t('Case Title')" sortable="custom" prop="case_title" v-if="selectedColumns.includes('case_title')" width="400" >
                                        <template slot-scope="scope">
                                             <el-tooltip v-if="$store.state.config.user.role_slug==='club-user' || $store.state.config.user.role_slug==='club'" class="item selfvoteinfo" effect="dark" :content="getClassName(scope.row.clubUSerCaseVote).contentInfo" placement="top">
                                                    <el-button :type="getClassName(scope.row.clubUSerCaseVote).className" size="mini" circle></el-button>
                                             </el-tooltip>
                                            <router-link :to="gotoDetail(scope.row)">{{ scope.row.case_title }}</router-link>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Fachstellen Name')" sortable="custom" prop="fachstellen_name" v-if="selectedColumns.includes('fachstellen_name') && !$store.state.config.user.fachstellen_slug && !fachstellen_slug" width="300">
                                        <template slot-scope="scope">
                                            <router-link :to="{name: 'FachstellenDashboard', params: {'fachstellen_slug': scope.row.fachstellen_slug }}" v-if="$store.getters.getConfig('has_permissions').includes('fachstellens-index')">
                                                {{ scope.row.fachstellen_name }}</router-link>
                                            <span v-else>{{ scope.row.fachstellen_name }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Godchild')" sortable="custom" prop="patenkinder_name" v-if="selectedColumns.includes('patenkinder_name')" width="250">
                                    </el-table-column>
                                    <el-table-column :label="$t('Status')" sortable="custom" prop="status" v-if="selectedColumns.includes('status')" width="190">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" :type="getStatusType(scope.row.status_key)" v-if="scope.row.is_new_case==0">
                                                {{ $t(scope.row.status_key) }}
                                            </el-tag>
                                            <el-tag size="mini" type="danger" v-else>
                                               <h4> {{ $t('Erstaufnahme')}} </h4>
                                            </el-tag>
                                        </template>
                                    </el-table-column> 
                                    <el-table-column :label="$t('Votes')" width="150" v-if="selectedColumns.includes('votes') && $store.state.config.user.role_slug.indexOf('fachstellen') < 0">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" type="success" class="vote-status-thumb">{{
                                                scope.row.case_up_votes }} <i class="icon-up-votes"></i> </el-tag>
                                            <el-tag size="mini" type="danger" class="vote-status-thumb">{{
                                                scope.row.case_down_votes }} <i class="icon-down-votes"></i></el-tag>
                                         </template>
                                    </el-table-column>                                   
                                    <el-table-column :label="$t('Approval Mail')" width="170">
                                        <template slot-scope="scope">
                                            <a href="javascript:void(0);" v-if="scope.row.email_send == 1 && ['rejected', 'donated'].includes(scope.row.status_key)" @click="sendMail(scope.row)"> <i class="el-icon-message"></i> {{ $t("To Fachstellen") }}</a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Created at')" sortable="custom" prop="created_at" v-if="selectedColumns.includes('created_at')" min-width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.created_at"></span>
                                        </template>
                                    </el-table-column>

                                     <el-table-column :label="$t('Expected amount')" sortable="custom" prop="expected_amount" v-if="selectedColumns.includes('expected_amount')" min-width="240">
                                        <template slot-scope="scope">
                                            {{ scope.row.expected_amount | currency-format}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column :label="$t('Confirmed Amount')" sortable="custom" prop="approved_amount" v-if="selectedColumns.includes('approved_amount')" min-width="240">
                                        <template slot-scope="scope">
                                            {{ scope.row.approved_amount | currency-format}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column :label="$t('payment_date')" sortable="custom" prop="payment_date" v-if="selectedColumns.includes('payment_date')" min-width="250">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.payment_date" v-date-format="scope.row.payment_date"></span>
                                            <span v-else>  </span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column :label="$t('payment_status')" sortable="custom" prop="payment_status" v-if="selectedColumns.includes('payment_status')" width="190">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" type="warning" v-if="scope.row.payment_status==1">
                                                 <h4> {{ $t('paid')}} </h4>
                                            </el-tag>
                                            <el-tag size="mini" type="danger" v-else>
                                               <h4> {{ $t('unpaid')}} </h4>
                                            </el-tag>
                                        </template>
                                    </el-table-column> 
                                   
                                    <el-table-column :label="$t('Modified at')" sortable="custom" prop="updated_at" v-if="selectedColumns.includes('updated_at')" min-width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.updated_at "></span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="my-content" v-else>
                                    <div class="grid-stack-item-content flexbox-div">
                                        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-for="(row,i) in cases.data" :key="row.id">
                                            <el-card class="grid-card inactive-card">
                                                <div class="card-row">
                                                    <div class="action-list">
                                                        <el-tag size="small" :type="getStatusType(row.status_key)" v-if="selectedColumns.includes('status')">
                                                            {{ $t(row.status_key) }}
                                                        </el-tag>
                                                        <ul class="act-list" v-if="row.status_key == 'stage_1' && ($store.getters.getConfig('has_permissions').includes('patenkinders-cases-update') || $store.getters.getConfig('has_permissions').includes('patenkinders-cases-destroy'))">
                                                            <li v-if="$store.getters.getConfig('has_permissions').includes('patenkinders-cases-update')">
                                                                <a href="javascript:void(0);" @click="handleEdit(row)"><i class="icon-edit"></i></a>
                                                            </li>
                                                            <li v-if="$store.getters.getConfig('has_permissions').includes('patenkinders-cases-destroy')">
                                                                <a href="javascript:void(0);" @click="handleDelete(i, row)"><i class=" icon-delete"></i></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="left-border-list" v-if="selectedColumns.includes('case_title')">
                                                        <h3>{{ $t('Case Title') }}</h3>
                                                        <p>
                                                            <router-link :to="gotoDetail(row)">{{ row.case_title }}</router-link>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="card-row">
                                                    <div class="left-border-list" v-if="selectedColumns.includes('fachstellen_name')">
                                                        <h3>{{ $t('Fachstellen Name') }}</h3>
                                                        <p>
                                                            <router-link :to="{name: 'FachstellenDashboard', params: {'fachstellen_slug': row.fachstellen_slug }}" v-if="$store.getters.getConfig('has_permissions').includes('fachstellens-index')">{{
                                                                row.fachstellen_name }}</router-link>
                                                            <span v-else>{{ row.fachstellen_name }}</span>
                                                        </p>
                                                    </div>
                                                    <div class="left-border-list" v-if="selectedColumns.includes('patenkinder_name')">
                                                        <h3>{{ $t('Godchild') }}</h3>
                                                        <p>{{ row.patenkinder_name }}</p>
                                                    </div>
                                                    <div class="left-border-list" v-if="selectedColumns.includes('votes') && $store.state.config.user.role_slug.indexOf('fachstellen') < 0">
                                                        <h3>{{ $t('Votes') }}</h3>
                                                        <p>
                                                            <el-tag size="mini" type="success" class="vote-status-thumb">{{
                                                                row.case_up_votes }} <i class="icon-up-votes"></i>
                                                            </el-tag>
                                                            <el-tag size="mini" type="danger" class="vote-status-thumb">{{
                                                                row.case_down_votes }} <i class="icon-down-votes"></i></el-tag>
                                                        </p>
                                                    </div>
                                                    <div class="left-border-list" v-if="selectedColumns.includes('created_at')">
                                                        <h3>{{ $t('Created at') }}</h3>
                                                        <p>
                                                            <span v-date-time-format="row.created_at"></span>
                                                        </p>
                                                    </div>

                                                    <div class="left-border-list" v-if="selectedColumns.includes('expected_amount')">
                                                        <h3>{{ $t('Expected amount') }}</h3>
                                                        <p>
                                                            {{ row.expected_amount | currency-format }}
                                                        </p>
                                                    </div>
                                                    <div class="left-border-list" v-if="selectedColumns.includes('approved_amount')">
                                                        <h3>{{ $t('Confirmed Amount') }}</h3>
                                                        <p>
                                                            {{ row.approved_amount | currency-format}}
                                                        </p>
                                                    </div>
                                                    <div class="left-border-list" v-if="selectedColumns.includes('payment_date')">
                                                        <h3>{{ $t('payment_date') }}</h3>
                                                        <p>
                                                            <span v-if="row.payment_date" v-date-format="row.payment_date"></span>
                                                            <span v-else></span>
                                                        </p>
                                                    </div>
                                                    <div class="left-border-list" v-if="selectedColumns.includes('payment_status')">
                                                        <h3>{{ $t('payment_status') }}</h3>
                                                        <p>
                                                            {{ row.payment_status }}
                                                        </p>
                                                    </div>
                                                    <div class="left-border-list" v-if="selectedColumns.includes('updated_at')">
                                                        <h3>{{ $t('Modified at') }}</h3>
                                                        <p>
                                                            <span v-date-time-format="row.updated_at"></span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </el-card>
                                        </el-col>
                                    </div>
                                </div>
                                <el-pagination v-if="cases.meta.total" background @size-change="handleSizeChange" @current-change="filterParams.page = filterData.page;getCases()" :current-page.sync="filterData.page" :page-sizes="[6, 12, 24, 66, 111]" :page-size="filterData.pageLength" layout="sizes, slot, ->, prev, pager, next" :total="cases.meta.total">
                                    <template>
                                        <span class="page-no">{{ $t('Showing out of records',{'0': cases.data.length,
                                            '1': cases.meta.total}) }}</span>
                                    </template>
                                </el-pagination>
                            </div>
                        </v-collapse-wrapper>
                    </v-collapse-group>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import CaseForm from './Form'
    export default {
        components: {
            "case-form": CaseForm
        },
        props: {
            organization_slug: String,
            fachstellen_slug: String,
            club_slug: String
        },
        data() {
            return {
                filterData: {
                    page: 1,
                    pageLength: process.env.KIPAKI_pageLength,
                    sortBy: "id",
                    order: "desc",
                    patenkinder_slug: null,
                    organization_slug: this.$store.state.config.user.organization_slug || this.organization_slug,
                    fachstellen_slug: this.$store.state.config.user.fachstellen_slug || this.fachstellen_slug,
                    club_slug: this.$store.state.config.user.club_slug || this.club_slug,
                    status: null
                },
                statusList: process.env.KIPAKI_status,
                dialogFormVisible: false,
                formLabelWidth: "120px",
                cases: {
                    meta: {},
                    data: []
                },
                rowData: {
                    payment_slip: [],
                    removed_payment_slip_doc: [],
                },
                fachstellenTypes: {},
                fachstellenList: {},
                patenkinderList: {},
                caseStages: {},
                column_name: [{
                        value: "case_title",
                        label: this.$t("Case Title")
                    },
                    {
                        value: "fachstellen_name",
                        label: this.$t("Fachstellen")
                    },
                    {
                        value: "patenkinder_name",
                        label: this.$t("Godchild")
                    },
                    {
                        value: 'status',
                        label: this.$t("Status")
                    },
                    {
                        value: 'votes',
                        label: this.$t("Votes")
                    },
                    {
                        value: 'created_at',
                        label: this.$t('Created at')
                    },
                    {
                        value: 'expected_amount',
                        label: this.$t('Expected amount')
                    },
                    {
                        value: 'approved_amount',
                        label: this.$t('Confirmed Amount')
                    },
                    {
                        value: 'payment_date',
                        label: this.$t('payment_date')
                    },
                    {
                        value: 'payment_status',
                        label: this.$t('payment_status')
                    },

                    {
                        value: 'updated_at',
                        label: this.$t('Modified at')
                    },
                ],
                selectedColumns: [],
                sortable: null,
                currentRow: {},
                dummyRow: {},
                downloadLoading: false,
                isOpenList: false,
                isOpen: false,
                listView: true,
                filterParams: {}
            };
        },
        mounted() {
            this.filterParams = Object.assign({}, this.filterData);
            this.selectedColumns = this.column_name.map(a => a.value)
            this.getCases();
            this.getAllFachstellenTypes();
            this.getAllFachstellen();
            this.getAllPatenkinder();
            this.getCaseStages();
        },
        methods: {
            getClassName(value) {
                if(value==='1') {
                    this.seftvote = 'success'; 
                    this.seftvoteInfo = 'up vote';
                } else if (value === '2') {
                    this.seftvote = 'danger'; 
                    this.seftvoteInfo = 'dowon vote';
                } else {
                    this.seftvote  = 'info'; 
                    this.seftvoteInfo = 'pending vote';
                }
                return { 'className': this.seftvote, 'contentInfo': this.seftvoteInfo };
            },
            getStatusType(status_key) {
                var statusType = '';
                switch (status_key) {
                    case 'stage_1':
                        statusType = 'info';
                        break;
                    case 'stage_2':
                        statusType = 'warning'
                        break;
                    case 'stage_3':
                        statusType = '';
                        break;
                    case 'donated':
                        statusType = 'success';
                        break;
                    default:
                        statusType = 'danger';
                }
                return statusType;
            },
            gotoDetail(tab) {
                if (tab.status_key == "stage_1" || tab.status_key == "donated" || tab.status_key == "rejected") {
                    return {
                        name: 'CaseDetails',
                        params: {
                            id: tab.id
                        }
                    };
                } else if (tab.status_key == "stage_2") {
                    return {
                        // name: 'CaseVoting',
                        name: 'CaseDetails',
                        params: {
                            id: tab.id
                        }
                    };
                } else {
                    return {
                        // name: 'CaseReview',
                        name: 'CaseDetails',
                        params: {
                            id: tab.id
                        }
                    };
                }
            },
            getCases() {
                request({
                    url: "patenkinder-cases",
                    method: "get",
                    params: this.filterParams
                }).then(response => {
                    this.cases = response.data;
                    this.cases.data = this.cases.data.map(v => {
                        this.$set(v, 'edit', false)
                        return v
                    });
                    setTimeout(() => {
                        $('table .el-tooltip').removeClass('el-tooltip');
                    });
                });
            },
            getAllFachstellenTypes() {
                request({
                    url: "get-all-fachstellentype",
                    method: "get"
                }).then(response => {
                    this.fachstellenTypes = response.data;
                });
            },
            getAllFachstellen() {
                request({
                    url: "get-all-fachstellen",
                    method: "get",
                    params: {
                        organization_slug: this.filterData.organization_slug,
                        club_slug: this.filterData.club_slug
                    }
                }).then(response => {
                    this.fachstellenList = response.data;
                });
            },
            getAllPatenkinder() {
                request({
                    url: "get-all-patenkinder",
                    method: "get",
                    params: {
                        fachstellen_slug: this.filterData.fachstellen_slug,
                        organization_slug: this.filterData.organization_slug,
                        club_slug: this.filterData.club_slug
                    }
                }).then(response => {
                    this.filterData.patenkinder_slug = null;
                    this.patenkinderList = response.data;
                });
            },
            getCaseStages() {
                request({
                    url: "get-all-case-status",
                    method: "get"
                }).then(response => {
                    this.caseStages = response.data.data;
                });
            },
            handleCreate() {
                if(this.patenkinderList.data.length == 0 && (!this.$parent.$parent.$parent.enjoyhint_instance || (this.$parent.$parent.$parent.enjoyhint_instance.getCurrentStep() != 1))) {
                    this.$alert(this.$t('Please first create a Patenkinder'), '', {
                        confirmButtonText: this.$t('OK'),
                        callback: action => {                            
                        }
                    }); 
                } else {                               
                    this.rowData = {
                        fachstellen_slug: null,
                        patenkinder_slug: null,
                        q_ans_1: 'no',
                        q_ans_2: 'no',
                        q_ans_3: 'no',
                        q_ans_4: 'no',
                        additions: [{
                            reason: null,
                            cost: null,
                            case_category_id: null
                        }],
                        confirmation: null,
                        payment_slip: [],
                        removed_payment_slip_doc: [],
                    };
                    this.dialogFormVisible = true;
                }
            },
            handleEdit(row) {
                this.rowData = row;
                this.rowData.edit = true;
                this.dialogFormVisible = true;
            },
            updateRow(row) {
                for (const v of this.cases.data) {
                    if (v.id === row.id) {
                        const index = this.cases.data.indexOf(v)
                        this.cases.data.splice(index, 1, row)
                        break
                    }
                }
            },
            handleDelete(index, row) {
                this.$confirm(
                    this.$t('This will permanently delete the') + ' ' + this.$t('Case') + '. ' + this.$t(
                        'Do you want to continue?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('OK'),
                        cancelButtonText: this.$t('Cancel'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    request({
                            url: "patenkinder-cases/" + row.id,
                            method: "delete",
                            data: {}
                        })
                        .then(response => {
                            this.getCases();
                            this.$notify({
                                title: this.$t('Success'),
                                message: response.data.message,
                                type: "success",
                                offset: 50
                            });
                        })
                        .catch(error => {
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                        });
                });
            },
            handleCurrentChange(event) {
                this.filterData.page = 1;
                this.filterParams = Object.assign({}, this.filterData);
                this.getCases(this.filterData.current_page);
            },
            handleSizeChange(event) {
                this.filterData.pageLength = event;
                this.filterParams.pageLength = event;
                this.getCases();
            },
            handleSortChange(event) {
                this.filterParams.sortBy = event.prop;
                if (event.order === "ascending") this.filterParams.order = "asc";
                else if (event.order === "descending") this.filterParams.order = "desc";
                else {
                    this.filterParams.sortBy = "id";
                    this.filterParams.order = "desc";
                }
                this.getCases();
            },
            indexMethod(index) {
                return index + this.filterData.pageLength * this.filterData.page - this.filterData.pageLength + 1
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.filterParams = Object.assign({}, this.filterData);
                this.getAllPatenkinder();
                this.getCases();
            },
            exportFile() {
                this.downloadLoading = true
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = this.column_name.filter(a => {
                        return this.selectedColumns.includes(a.value)
                    }).map(b => b.label);
                    const data = this.formatJson(this.selectedColumns, this.cases.data)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: this.$t('Case')
                    })
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    if (j == "votes") {
                        return v['case_up_votes'] + '-' + this.$t('Agree') + '    ' + v['case_down_votes'] + '-' + this.$t('Not agree');
                    }
                    return v[j]
                }))
            },
            // Methods for More Action to each row
            showMoreActions: function (event) {
                event.target.parentNode.parentNode.parentNode.nextElementSibling.classList.toggle("open_list");
            },
            // method for collapsible panel
            activateClass: function (event) {
                event.target.classList.toggle("open");
            },
            sendMail(row) {
                request({
                    url: "send-case-status-update/" + row.id,
                    method: "get",
                    data: {}
                })
                .then(response => {
                    this.getCases();
                    this.$notify({
                        title: this.$t('Success'),
                        message: response.data.message,
                        type: "success",
                        offset: 50
                    });
                })
                .catch(error => {
                    this.$notify({
                        title: this.$t('Error'),
                        message: error.response.data.message,
                        type: "error",
                        offset: 50
                    });
                });
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Cases/Cases.vue